import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TwinMaterialsKeyType {
  plural: LocalesKey;
  createButton: LocalesKey;
  createTitle: LocalesKey;
  editTitle: LocalesKey;
  deleteTitle: LocalesKey;
  deleteWarning: LocalesKey;
  company: LocalesKey;
  crmMaterial: LocalesKey;
  glbAsset: LocalesKey;
  glbMaterialName: LocalesKey;
  swatchColor: LocalesKey;
  materialGroup: LocalesKey;
  noMaterials: LocalesKey;
  addMaterial: LocalesKey;
  backendBlocked: LocalesKey;
  bulkAddButton: LocalesKey;
  bulkCreateTitle: LocalesKey;
  crmMaterials: LocalesKey;
  noGroup: LocalesKey;
  searchPlaceholder: LocalesKey;
  selectZone: LocalesKey;
  allowedCount: LocalesKey;
  zones: {
    plural: LocalesKey;
    noZones: LocalesKey;
    noTemplate: LocalesKey;
    noMaterials: LocalesKey;
    createTemplate: LocalesKey;
    save: LocalesKey;
    setDefault: LocalesKey;
  };
}

export const twinMaterialsKeys = keyPathMirror<TwinMaterialsKeyType, string>(
  {
    plural: null,
    createButton: null,
    createTitle: null,
    editTitle: null,
    deleteTitle: null,
    deleteWarning: null,
    company: null,
    crmMaterial: null,
    glbAsset: null,
    glbMaterialName: null,
    swatchColor: null,
    materialGroup: null,
    noMaterials: null,
    addMaterial: null,
    backendBlocked: null,
    bulkAddButton: null,
    bulkCreateTitle: null,
    crmMaterials: null,
    noGroup: null,
    searchPlaceholder: null,
    selectZone: null,
    allowedCount: null,
    zones: {
      plural: null,
      noZones: null,
      noTemplate: null,
      noMaterials: null,
      createTemplate: null,
      save: null,
      setDefault: null
    }
  },
  'models.twinMaterials.'
);
